// extracted by mini-css-extract-plugin
module.exports = {"FormSection":"styles_FormSection__1oivU","FormSectionBlocked":"styles_FormSectionBlocked__79Vw2"};